module.exports = __webpack_public_path__ + "img/logo-dark.a0947b50.svg";